import React from 'react';
import {
  Link
} from "react-router-dom";
import config from './../config.js';
import Aside from './common/aside.js';

import ProjectImageList from './project_image_list.js';
//import ProjectBrainlabel from './project_service_brainlabel.js';
import ListBrainlabel from './uncategorized/list_brainlabel.js';
import ListPet from './uncategorized/list_pet.js';
//import ProjectRelatedPetList from './project_service_related_pet.js';

import Notification from 'rc-notification';
let notification = null;
Notification.newInstance({
  style: {
    top: '45px',
    right: 0
  }
}, (n) => notification = n);

class ProjectServiceList extends React.Component {
  constructor(props) {
    super(props);
    //console.log(props);

    let user = {};
    if (typeof localStorage.token !== 'undefined' && localStorage.token !== '') {
      user = JSON.parse(localStorage.user);
    }
    const {
      projectid,
      type
    } = props.match.params;
    const pagetitle = '项目管理 ';
    this.state = {
      user: user,
      page_title: pagetitle,
      page_subtitle: type.toUpperCase() + ' 分析列表',
      projectid: projectid,
      type: type,
      project: '',
      creator: ''
    }

    document.title = pagetitle + type.toUpperCase() + ' 分析列表';
    this.goback = this.goback.bind(this);

  }

  componentDidMount() {
    if (this.state.projectid > 0) this.getProject();
  }

  goback() {
    const me = this;
    //this.props.history.goBack(1);
    me.props.history.push('/console/myprojects/project/' + me.state.projectid + '/MR');
  }

  notify(message) {
    notification.notice({
      content: <span>{message}</span>,
      duration: 4,
      style: {
        'bottom': 0,
        'right': 0
      }
    });
  }

  componentWillReceiveProps(nextProps) {
    const {
      projectid,
      type
    } = nextProps.match.params;
    this.setState({
      page_subtitle: type.toUpperCase() + ' 分析列表',
      type: type
    });
    document.title = this.state.page_title + type.toUpperCase() + ' 分析列表';
    //this.getProject();
  }


  getProject() {
    const me = this;

    let {
      projectid,
      user
    } = me.state;
    const postdata = {
      userid: user.id,
      companyid: user.company_id,
      projectid: projectid,
      Authorization: localStorage.token,
      request: 'project'
    };
    fetch(config.host + '/project/index', {
        method: 'post',
        body: JSON.stringify(postdata)
      })
      .then(res => res.json())
      .then(json => {
        //console.log(json);
        if (json.status === 1) {
          const data = json.data;
          me.setState({
            project: data.project,
            creator: data.creator
          });
        } else {
          me.notify(json.message);
        }
      })
      .catch(function(error) {
        console.log(error);
      });
  }



  render() {
    const {
      type,
      creator
    } = this.state;
    return (
      <div className="row">
        <div className="col-10">
            <nav className="animated fadeInDown">
              <ol className="breadcrumb pb-0 px-0">
                <li className="breadcrumb-item">
                  <a onClick={()=>this.goback()} ><strong><i className="fa fa-chevron-left"></i> 返回</strong></a>
                </li>
                {this.state.project!='' && 
                  <li className="breadcrumb-item">
                    <Link className="text-dark " to={`/console/myprojects/project/${this.state.projectid}/MR`}><strong> {this.state.project.name}</strong></Link>
                  </li>
                }
                {this.state.creator!='' && 
                  <li className="breadcrumb-item active">
                    创建者: {creator.realname || creator.email || creator.title || creator.address || creator.office}
                  </li>
                }
                <li className="breadcrumb-item " aria-current="page">{this.state.page_subtitle}</li>
              </ol>
            </nav>

          <div>
          { 
            (type === 'vbm' || type==='tbss' ) && 
            <ProjectImageList data={this.props.match.params} creator={creator} />
          }
          {
            type =='brainlabel'  && <ListBrainlabel data={this.props.match.params} pathurl={this.props.location.pathname} />
          }
          {
            type == 'pet' &&  <ListPet   data={this.props.match.params} pathurl={this.props.location.pathname} />
          }
          </div>
        </div>
        <div className="col-2  pl-0 pr-0">
          <Aside data={this.props.match.params} />
        </div>
      </div>
    );
  }
}

export default ProjectServiceList;


// WEBPACK FOOTER //
// ./src/apps/console/project_service_list.js